import { PUBLIC_GRAPHQL_OPERATION_NAMES } from './public-operations';

export const getPrivateApiUrl = (): string => import.meta.env.VITE_API_URL;

export const getPublicApiUrl = (): string => import.meta.env.VITE_API_PUBLIC_URL;

export const getGraphqlEndpoint = (isPublic: boolean): string =>
  `${isPublic ? getPublicApiUrl() : getPrivateApiUrl()}/api/v1`;

export const getWsEndpoint = (): string => {
  const baseUrl = getPrivateApiUrl()?.trim();

  if (!baseUrl) {
    return '/api/v1';
  }

  const httpUrl = `${baseUrl}/api/v1`;

  if (httpUrl.startsWith('https://')) {
    return `wss://${httpUrl.slice('https://'.length)}`;
  }

  if (httpUrl.startsWith('http://')) {
    return `ws://${httpUrl.slice('http://'.length)}`;
  }

  return httpUrl.startsWith('/') ? httpUrl : `/${httpUrl}`;
};

export const buildPrivateApiPath = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getPrivateApiUrl()}${normalizedPath}`;
};

export const buildPublicApiPath = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getPublicApiUrl()}${normalizedPath}`;
};

export const isPublicGraphqlOperation = (operationName?: string | null): boolean =>
  !!operationName && PUBLIC_GRAPHQL_OPERATION_NAMES.has(operationName);
